import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TonalOffset from './TonalOffset';
import ClientProvider from './client';
export default createDemo(import.meta.url, TonalOffset, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/palette/demos/tonal-offset/TonalOffset.tsx",
    "fileName": "TonalOffset.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';\nimport { blue } from '@mui/material/colors';\nimport Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Typography from '@mui/material/Typography';\n\nconst defaultTonalOffsetTheme = createTheme({\n  palette: {\n    primary: {\n      main: blue[500],\n    },\n  },\n});\n\nconst higherTonalOffsetTheme = createTheme({\n  palette: {\n    primary: {\n      main: blue[500],\n    },\n    tonalOffset: 0.5,\n  },\n});\n\nconst asymmetricTonalOffsetTheme = createTheme({\n  palette: {\n    primary: {\n      main: blue[500],\n    },\n    tonalOffset: {\n      light: 0.1,\n      dark: 0.9,\n    },\n  },\n});\n\nfunction ColorShowcase({ title, color }: { title: string; color: string }) {\n  const {\n    palette: { tonalOffset },\n  } = useTheme();\n\n  let caption;\n  if (typeof tonalOffset === 'number') {\n    caption = tonalOffset;\n  } else {\n    caption = `{ light: ${tonalOffset.light}, dark: ${tonalOffset.dark} }`;\n  }\n\n  return (\n    <Stack sx={{ gap: 1, alignItems: 'center' }}>\n      <span>\n        <b>{title}</b>\n      </span>\n      <span>{caption}</span>\n      <Stack direction=\"row\" sx={{ gap: 1 }}>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">light</Typography>\n          <Box sx={{ bgcolor: `${color}.light`, width: 40, height: 20 }} />\n        </Stack>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">main</Typography>\n          <Box sx={{ bgcolor: `${color}.main`, width: 40, height: 20 }} />\n        </Stack>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">dark</Typography>\n          <Box sx={{ bgcolor: `${color}.dark`, width: 40, height: 20 }} />\n        </Stack>\n      </Stack>\n    </Stack>\n  );\n}\n\nexport default function TonalOffset() {\n  return (\n    <Stack direction={{ xs: 'column', sm: 'row' }} sx={{ gap: 8 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <ThemeProvider theme={defaultTonalOffsetTheme}>\n        <ColorShowcase title=\"Default tonal offset\" color=\"primary\" />\n      </ThemeProvider>\n      <ThemeProvider theme={higherTonalOffsetTheme}>\n        <ColorShowcase title=\"Higher tonal offset\" color=\"primary\" />\n      </ThemeProvider>\n      <ThemeProvider theme={asymmetricTonalOffsetTheme}>\n        <ColorShowcase title=\"Asymmetric tonal offset\" color=\"primary\" />\n      </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 86,
        "focusedLines": 9,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';\nimport { blue } from '@mui/material/colors';\nimport Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Typography from '@mui/material/Typography';\n\nconst defaultTonalOffsetTheme = createTheme({\n  palette: {\n    primary: {\n      main: blue[500],\n    },\n  },\n});\n\nconst higherTonalOffsetTheme = createTheme({\n  palette: {\n    primary: {\n      main: blue[500],\n    },\n    tonalOffset: 0.5,\n  },\n});\n\nconst asymmetricTonalOffsetTheme = createTheme({\n  palette: {\n    primary: {\n      main: blue[500],\n    },\n    tonalOffset: {\n      light: 0.1,\n      dark: 0.9,\n    },\n  },\n});\n\nfunction ColorShowcase({ title, color }: { title: string; color: string }) {\n  const {\n    palette: { tonalOffset },\n  } = useTheme();\n\n  let caption;\n  if (typeof tonalOffset === 'number') {\n    caption = tonalOffset;\n  } else {\n    caption = `{ light: ${tonalOffset.light}, dark: ${tonalOffset.dark} }`;\n  }\n\n  return (\n    <Stack sx={{ gap: 1, alignItems: 'center' }}>\n      <span>\n        <b>{title}</b>\n      </span>\n      <span>{caption}</span>\n      <Stack direction=\"row\" sx={{ gap: 1 }}>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">light</Typography>\n          <Box sx={{ bgcolor: `${color}.light`, width: 40, height: 20 }} />\n        </Stack>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">main</Typography>\n          <Box sx={{ bgcolor: `${color}.main`, width: 40, height: 20 }} />\n        </Stack>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">dark</Typography>\n          <Box sx={{ bgcolor: `${color}.dark`, width: 40, height: 20 }} />\n        </Stack>\n      </Stack>\n    </Stack>\n  );\n}\n\nexport default function TonalOffset() {\n  return (\n    <Stack direction={{ xs: 'column', sm: 'row' }} sx={{ gap: 8 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <ThemeProvider theme={defaultTonalOffsetTheme}>\n        <ColorShowcase title=\"Default tonal offset\" color=\"primary\" />\n      </ThemeProvider>\n      <ThemeProvider theme={higherTonalOffsetTheme}>\n        <ColorShowcase title=\"Higher tonal offset\" color=\"primary\" />\n      </ThemeProvider>\n      <ThemeProvider theme={asymmetricTonalOffsetTheme}>\n        <ColorShowcase title=\"Asymmetric tonal offset\" color=\"primary\" />\n      </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 75
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "defaultTonalOffsetTheme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 76
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "ColorShowcase"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "title"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Default tonal offset",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "primary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 77
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 78
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "higherTonalOffsetTheme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 79
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "ColorShowcase"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "title"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Higher tonal offset",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "primary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 80
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 81
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "asymmetricTonalOffsetTheme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 82
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "ColorShowcase"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "title"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Asymmetric tonal offset",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "primary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 83
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 86,
    "focusedLines": 9,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/colors",
      "@mui/material/Box",
      "@mui/material/Stack",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
